import { useState } from "react";
import { createPortal } from "react-dom";
import s from "./AccountPage.module.scss";
import closeBtn from "../../icons/closeIcon.svg";
import classNames from "classnames";
import RadioButtton from "components/RadioButtton/RadioButtton";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  deleteDate: string;
  onConfirm: (data: { reason: string; other_reason?: string }) => void;
};

export const DeleteAccountModal = ({ isOpen, onClose, onConfirm }: Props) => {
  const [selectedReasons, setSelectedReasons] = useState("");
  const [otherReasonText, setOtherReasonText] = useState("");

  const [error, setError] = useState("");

  // Функция для полного сброса состояния
  const resetState = () => {
    setSelectedReasons("");
    setOtherReasonText("");
    setError("");
  };
  const handleClose = () => {
    resetState();
    onClose();
  };

  const handleConfirm = async () => {
    if (selectedReasons === "other" && !otherReasonText.trim()) {
      setError("Необходимо указать причину удаления");
      return;
    }

    try {
      onConfirm({
        reason: selectedReasons,
        ...(selectedReasons === "other" && { other_reason: otherReasonText }),
      });
      handleClose();
    } catch (error) {
      console.error("Ошибка при удалении:", error);
    }
  };

  const handleReasonChange = (reason: string) => {
    setSelectedReasons(reason);
    setError("");
    if (reason !== "other") {
      setOtherReasonText("");
    }
  };

  if (!isOpen) return null;

  return createPortal(
    <div className={s.overlay} onClick={onClose}>
      <div className={s.modal} onClick={(e) => e.stopPropagation()}>
        <div className={s.modalCloseBtn}>
          <button type="button">
            <img src={closeBtn} alt="" onClick={handleClose} />
          </button>
        </div>

        <h2 className={s.title}>Удалить аккаунт</h2>

        <div className={s.modalContent}>
          <div className={s.modalContent_Wrapp}>
            <p className={s.greeting}>Привет, дружище!</p>
            <p className={s.warning}>
              Жаль слышать, что ты решил удалить свой аккаунт.
            </p>
            <p className={s.warning1}>
              К сожалению, восстановить его не получится, и вся твоя{" "}
              <span className={s.warningSpan}>статистика будет утеряна.</span>{" "}
            </p>
          </div>
          <div className={s.reasons}>
            <p className={s.question}>Почему ты хочешь удалить свой аккаунт?</p>

            <label className={s.reason}>
              <RadioButtton
                checked={selectedReasons === "not_interested"}
                onChange={() => handleReasonChange("not_interested")}
                size={24}
                strokeColor="#262429"
                fillColor="#262429"
                uncheckedColor="#C0BBC7"
                aria-label="Не интересно больше"
              />
              <span className={s.span}>Не интересно больше</span>
            </label>

            <label className={s.reason}>
              <RadioButtton
                checked={selectedReasons === "too_much_ads"}
                onChange={() => handleReasonChange("too_much_ads")}
                size={24}
                strokeColor="#262429"
                fillColor="#262429"
                uncheckedColor="#C0BBC7"
                aria-label="Слишком много рекламы"
              />

              <span className={s.span}>Слишком много рекламы</span>
            </label>

            <label className={s.reason}>
              <RadioButtton
                checked={selectedReasons === "other"}
                onChange={() => handleReasonChange("other")}
                size={24}
                strokeColor="#262429"
                fillColor="#262429"
                uncheckedColor="#C0BBC7"
                aria-label="Что-то другое"
              />
              <span className={s.span}>Что-то другое</span>
            </label>

            <div
              className={classNames(
                s.otherReasonWrapper,
                selectedReasons === "other" && s.active
              )}
            >
              <textarea
                className={s.otherReasonInput}
                placeholder="Пожалуйста, уточните причину"
                value={otherReasonText}
                onChange={(e) => {
                  setOtherReasonText(e.target.value);
                  setError("");
                }}
                rows={3}
                disabled={selectedReasons !== "other"}
              />
              {error && <span className={s.error}>{error}</span>}
            </div>
          </div>

          <button
            className={`${s.deleteButton} ${
              selectedReasons ? s.deleteButton_active : ""
            }`}
            onClick={handleConfirm}
          >
            Удалить аккаунт
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};
